export enum EFilesType {
    UPLOADS = 'uploads',
    RESULTS = 'results',
}
